import { Dialog, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

type ModalProps = {
  children: React.ReactNode;
  open: boolean;
  handleClose: () => void;
  title?: string;
};

export default function Modal({ open, handleClose, title, children }: ModalProps): JSX.Element {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <div style={{ padding: '1rem', position: 'relative' }}>
        {title && <Typography variant="h6">{title}</Typography>}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          style={{ position: 'absolute', top: '0.5rem', right: '0.5rem' }}
        >
          <Close />
        </IconButton>
        {children}
      </div>
    </Dialog>
  );
}
